<template>
  <!-- eslint-disable-next-line vue/no-undef-components -->
  <notifications position="top center" />
  <BaseLayout :isInitialized="isInitialized">
    <RouterView :key="route.fullPath" />
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from '@/layouts/BaseLayout.vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import { onBeforeMount, ref } from 'vue';
import { Configuration } from '@swpsoftware/commons-api';
import { useAuthorizationStore, useLoadingStore } from '@swpsoftware/commons-vue';
import { goToLogin } from '@/utils/LoginHelper';
import { getErrorMessage } from '@/services/ErrorMessageProvider';
import { useTemplateBaseDataStore } from '@/stores/TemplateBaseDataStore';
import { useFeatureStore } from '@/stores/FeatureStore';

const loadingStore = useLoadingStore();
const router = useRouter();
const route = useRoute();

const isInitialized = ref(false);

onBeforeMount(async () => {
  await loadingStore.startLoading('init', async () => {
    try {
      await loadingStore.loadAuthenticationState();

      await router.isReady();

      if (!loadingStore.isAuthenticated) {
        goToLogin();
        return;
      }

      await Promise.all([
        useAuthorizationStore().loadRights(Configuration.getApiUrl('Authorization')),
        useFeatureStore().loadFeatures(),
        useTemplateBaseDataStore().init(),
      ]);

      if (route.query?.bootstrap === 'true') {
        await router.replace({ query: {} });
      }
    } catch (e) {
      throw new Error(getErrorMessage(e));
    }
  });

  isInitialized.value = true;
});
</script>

<style lang="scss">
@import '@swpsoftware/vue-components/dist/breakpoints.scss';

main {
  padding: 0 !important;
}

:root {
  --theme: #4399cb;
  --theme-hover: #3a83ad;
  --theme-light: #edf7fd;
}

.dx-treelist-search-text {
  color: var(--text);
  background-color: var(--highlight);
}

/* hack to fix the sidebar */
.sidebar *,
.sidebar ::before,
.sidebar ::after {
  box-sizing: content-box;
}

.clickable {
  cursor: pointer;
}

.color-theme {
  color: var(--theme) !important;
}

a.color-theme:hover {
  color: var(--theme-hover) !important;
}

.desktop-only {
  display: none;
}

.vue-notification-group {
  top: 90px !important;
}

@media screen and (min-width: $breakpoint-lg) {
  .vue-notification-group {
    top: 10px !important;
  }

  .desktop-only {
    display: initial;
  }
}

.dx-button.dx-state-focused [class$='-text'] {
  text-decoration: none !important;
}

/* popover link */
.popover-link {
  .dx-popup-normal {
    width: auto !important;
    max-width: 500px;
    .dx-popup-content {
      padding: 10px;
    }
  }
}

.description-text-area {
  .dx-texteditor-input-container {
    margin: 7px 0;
  }
}
</style>
